import React from 'react'
import { createHashRouter, RouterProvider } from 'react-router-dom'

import HomePage from './pages/HomePage'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import ClientPortalLogin from './pages/ClientPortalLogin'
import ClientPortalInvite from './pages/ClientPortalInvite'
import ClientPortalDashboard from './pages/ClientPortalDashboard'
import ClientPortalProjectDetails from './pages/ClientPortalProjectDetails'
import DevVaultPrivacy from './pages/DevVaultPrivacy'
import NotFound from './pages/NotFound'
import EuronodesAuthComplete from './pages/EuronodesAuthComplete'
import './lib/euronodesAuth'

// Support pretty URL for DevVault privacy page
if (
  window.location.pathname === '/devvault-privacy' &&
  !window.location.hash
) {
  window.location.replace('/#/devvault-privacy')
}

const router = createHashRouter([
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin/*',
    element: <AdminDashboard />
  },
  {
    path: '/portal/invite/:token',
    element: <ClientPortalInvite />
  },
  {
    path: '/portal/login',
    element: <ClientPortalLogin />
  },
  {
    path: '/portal/projects/:projectId',
    element: <ClientPortalProjectDetails />
  },
  {
    path: '/portal',
    element: <ClientPortalDashboard />
  },
  {
    path: '/auth/complete',
    element: <EuronodesAuthComplete />
  },
  {
    path: '/devvault-privacy',
    element: <DevVaultPrivacy />
  },
  {
    path: '*',
    element: <NotFound />
  }
])

export default function App() {
  return <RouterProvider router={router} />
}